import { ImageDimensions } from './imageEditConstants';

export const calculateDisplayDimensions = (
  naturalWidth: number,
  naturalHeight: number,
  maxWidth: number,
  maxHeight: number
): ImageDimensions => {
  const aspectRatio = naturalWidth / naturalHeight;
  const isMobile = window.innerWidth < 768;
  const isTablet = window.innerWidth >= 768 && window.innerWidth < 1024;
  
  let containerWidth, maxDisplayHeight;
  
  if (isMobile) {
    containerWidth = Math.min(window.innerWidth - 40, naturalWidth);
    maxDisplayHeight = window.innerHeight * 0.5;
  } else if (isTablet) {
    containerWidth = Math.min(window.innerWidth * 0.6, naturalWidth);
    maxDisplayHeight = window.innerHeight * 0.6;
  } else {
    const availableWidth = window.innerWidth * 0.6;
    containerWidth = Math.min(availableWidth - 100, naturalWidth, 600);
    maxDisplayHeight = window.innerHeight * 0.7;
  }

  let displayWidth = Math.min(containerWidth, naturalWidth);
  let displayHeight = displayWidth / aspectRatio;

  if (displayHeight > maxDisplayHeight) {
    displayHeight = maxDisplayHeight;
    displayWidth = displayHeight * aspectRatio;
  }

  return {
    width: Math.round(displayWidth),
    height: Math.round(displayHeight),
  };
};

export const calculateResponsiveDefaultDimensions = (
  maxWidth: number,
  maxHeight: number
): ImageDimensions => {
  const isMobile = window.innerWidth < 768;
  const isTablet = window.innerWidth >= 768 && window.innerWidth < 1024;
  
  let containerWidth, maxDisplayHeight;
  
  if (isMobile) {
    containerWidth = Math.min(window.innerWidth - 40, maxWidth);
    maxDisplayHeight = window.innerHeight * 0.5;
  } else if (isTablet) {
    containerWidth = Math.min(window.innerWidth * 0.6, maxWidth);
    maxDisplayHeight = window.innerHeight * 0.6;
  } else {
    const availableWidth = window.innerWidth * 0.6;
    containerWidth = Math.min(availableWidth - 100, maxWidth, 600);
    maxDisplayHeight = window.innerHeight * 0.7;
  }
  
  const displayWidth = Math.min(containerWidth, maxWidth);
  const displayHeight = Math.min(maxDisplayHeight, maxHeight);
  
  return { width: displayWidth, height: displayHeight };
};
